import { Item } from '@components/common/ItemGuessBox'

export const sortAlpha = (list: Item[]): Item[] => {
  return list.sort((a, b) => a.title.localeCompare(b.title))
}

export const sortIndex = (list: Item[]): Item[] => {
  return list.sort((a, b) => a.index - b.index)
}

export const toSoloItems = (list: Item[], length: number): Item[] => {
  return list
    .slice()
    .sort((a, b) => a.index - b.index)
    .slice(0, length)
    .map((item, i) => ({
      ...item,
      index: i + 1,
      points: 1,
    }))
}
